import { Component } from "react";
import { connect } from "react-redux";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDInput from "components/MDInput";

import { SET_LOCATION_NAME_EN } from "actions/types";

class Step2 extends Component {
	sendState() {
		return this.state;
	}

	isValidated() {
		return true;
	}

	render() {
		const { dispatch, lang, isFetching } = this.props;

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<MDInput
						label="Nom"
						id="name-en"
						fullWidth
						value={lang?.en?.name || ""}
						onChange={e =>
							dispatch({
								type: SET_LOCATION_NAME_EN,
								payload: e.target.value
							})
						}
						disabled={isFetching}
					/>
				</Grid>
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const { isFetching, lang } = state.locationReducer;

	return {
		isFetching,
		lang
	};
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(
	Step2
);
